import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WithSidebar from 'Layout/WithSidebar';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import Banner from 'components/Banner';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import {
    selectCropNutritionPage,
    fetchCropNutritionPage,
    selectCropNutritionPageCrops,
    // selectAllCropNutritionOptions,
    selectCropNutritionPageIsLoading,
    // setCurrentProductFilter,
    // selectCurrentProductFilterForCropNutrition,
} from 'store/slices/CropNutritionSlice';
import { ROUTES } from 'constants/routes';
import { fetchCropNutritionPageCrops } from 'store/slices/CropNutritionSlice';
import { type_nutrition } from 'api/constants';
// import NewDropdown from 'components/Dropdown';
// import { selectProductsOptions } from 'store/slices/ProductsSlice';
// import Filter from 'components/FilterNew';
import { scrollToSection } from 'helpers';
import Preloader from 'Layout/Preloader';
import { useAnimation } from 'hooks/useAnimation';

const CropNutritionPrograms = () => {
    const dispatch = useDispatch();
    const loading = useSelector(selectCropNutritionPageIsLoading);
    // const currentProductFilter = useSelector(selectCurrentProductFilterForCropNutrition);

    const {
        fs_title,
        fs_title_background,
        fs_view_button,
        agricultural_tag,
        agricultural_title,
        // filter_name,
        // crop_select,
        // product_select,
    } = useSelector(selectCropNutritionPage);

    const crops = useSelector(selectCropNutritionPageCrops);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchCropNutritionPage());
        // @ts-ignore
        dispatch(fetchCropNutritionPageCrops({ type: type_nutrition, all: true }));

        // dispatch(setCurrentProductFilter(null));
    }, [dispatch]);

    // const productsOptions = useSelector(selectProductsOptions);
    // const cropsOptions = useSelector(selectAllCropNutritionOptions);

    // const [selectedCrop, setSelectedCrop] = useState(null);

    // const handleProductsFilterChange = option => dispatch(setCurrentProductFilter(option));
    // const handleCropsFilterChange = option => setSelectedCrop(option);

    // useEffect(() => {
    //     if (currentProductFilter || selectedCrop) {
    //         dispatch(
    //             // @ts-ignore
    //             fetchCropNutritionPageCrops({
    //                 all: true,
    //                 type: type_nutrition,
    //                 product: currentProductFilter?.value || null,
    //                 slug: selectedCrop?.value || null,
    //             }),
    //         );
    //     }
    // }, [dispatch, currentProductFilter, selectedCrop]);

    // const handleReset = () => {
    //     setSelectedCrop(null);
    //     dispatch(setCurrentProductFilter({}));
    //     // @ts-ignore
    //     dispatch(fetchCropNutritionPageCrops({ type: type_nutrition, all: true }));
    // };

    const handleClick = () => scrollToSection('box', 100);

    // const FilterComponent = () => (
    //     <Filter onReset={handleReset} hasSelected={currentProductFilter || selectedCrop} title={filter_name}>
    //         <NewDropdown
    //             label={crop_select}
    //             options={cropsOptions}
    //             onChange={handleCropsFilterChange}
    //             selectedValue={selectedCrop}
    //         />
    //         <NewDropdown
    //             label={product_select}
    //             options={productsOptions}
    //             onChange={handleProductsFilterChange}
    //             selectedValue={currentProductFilter}
    //         />
    //     </Filter>
    // );

    const container = useRef();

    useAnimation({
        items: ['.with-sidebar-layout'],
        container,
        dependencies: [loading],
    });

    if (loading) return <Preloader />;

    return (
        <div ref={container}>
            <Banner
                title={fs_title}
                image={fs_title_background}
                buttonText={fs_view_button}
                onClickButton={handleClick}
            />

            <section className="container">
                <div className="inner-container type-3">
                    <div className="main-text-container">
                        <LabelButton>{agricultural_tag}</LabelButton>
                        <GradientText className="has-animation">
                            <span dangerouslySetInnerHTML={{ __html: agricultural_title }} />
                        </GradientText>
                    </div>
                </div>

                {/* <WithSidebar Sidebar={<FilterComponent />}>
                    <div className="box">
                        <ProductItems data={crops} baseRoute={ROUTES.cropNutritionPrograms} />
                    </div>
                </WithSidebar> */}

                <div className="box">
                    <ProductItems data={crops} baseRoute={ROUTES.cropNutritionPrograms} withSixItems />
                </div>
            </section>

            <DefaultForm />
        </div>
    );
};

export default CropNutritionPrograms;
